/**
 * Cloche de notifications du bandeau supérieur : badge rouge avec le nombre de non-lues
 * (plafonné à « 9+ »), clic → modale Notifications. Le compteur vit dans
 * useNotificationUnreadCount (fetch au montage + rafraîchi en temps réel).
 */
import React, { useState } from "react";
import { FiBell } from "react-icons/fi";
import { useNotificationUnreadCount } from "../Realtime/useNotifications";
import { NotificationsModal } from "./NotificationsModal";

export const NotificationBell: React.FC = () => {
	const count = useNotificationUnreadCount();
	const [open, setOpen] = useState(false);

	return (
		<>
			<button
				type="button"
				aria-label="Notifications"
				title="Notifications"
				onClick={() => setOpen(true)}
				className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
			>
				<FiBell className="h-5 w-5" />
				{count > 0 && (
					<span className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-rose-600 px-1 text-[10px] font-bold leading-none text-white">
						{count > 9 ? "9+" : count}
					</span>
				)}
			</button>
			<NotificationsModal open={open} onClose={() => setOpen(false)} />
		</>
	);
};

export default NotificationBell;
